import { Link } from '@tanstack/react-router';
import styled from 'styled-components';
import { WBSButton } from './WBSButton';

interface BannerMessageProps {
  text: string;
  buttonText?: string;
  buttonTo?: string;
  buttonParams?: Record<string, any>;
  buttonOnClick?: () => void;
}

export function BannerMessage({
  text,
  buttonText,
  buttonTo,
  buttonParams,
  buttonOnClick,
}: BannerMessageProps) {
  return (
    <BannerContainer>
      <BannerText>{text}</BannerText>
      {buttonText && buttonTo && (
        <WBSButton wide as={Link} to={buttonTo} params={buttonParams}>
          {buttonText}
        </WBSButton>
      )}
      {buttonText && buttonOnClick && (
        <WBSButton wide onClick={buttonOnClick}>
          {buttonText}
        </WBSButton>
      )}
    </BannerContainer>
  );
}

const BannerContainer = styled.div`
  background-color: var(--grey-100);
  border-left: 5px solid var(--wbs-red);
  box-sizing: border-box;
  padding: 20px 24px;
  width: 100%;
`;

const BannerText = styled.p`
  color: var(--grey-900);
  flex: 1;
  font-family: var(--raleway);
  font-size: 16px;
  line-height: 1.8;
  margin: 0 0 20px 0;
`;
